import * as React from 'react';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import { CoreGiftCardCreditCards } from '../schemas/rql';
import SelectableCreditCardListPlaceholder from '../credit_cards/selectable_credit_card_list_placeholder';
import GiftCardCreditCardOnFile from './gift_card_credit_card_on_file';

export type Props = ChildProps<CoreGiftCardCreditCards.Variables, CoreGiftCardCreditCards.Query>;

const withQuery = graphql<Props, CoreGiftCardCreditCards.Query>(gql`
query Core_Gift_Card_Credit_Cards {
  me {
    uuid
    creditCards {
      id
      last4
      cardType
      expirationMonth
      expirationYear
    }
  }
}`,
);

export function GiftCardCreditCardsOnFile(props: Props) {
  const [selectedCreditCardId, setSelectedCreditCardId] = React.useState(null);

  if (props.data.loading) {
    return <SelectableCreditCardListPlaceholder />;
  }

  const { creditCards } = props.data.me;
  return (
    <ul>
      {creditCards.map(creditCard =>
        <GiftCardCreditCardOnFile
          key={creditCard.id}
          creditCard={creditCard}
          onSelect={setSelectedCreditCardId}
          selected={selectedCreditCardId === creditCard.id}
        />,
      )}
    </ul>
  );
}

export default withQuery(GiftCardCreditCardsOnFile);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/gift_card_credit_cards_on_file.tsx